// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"a8146d6f","156":"81049eda","187":"a1295990","228":"91962470","232":"c3f6cbbf","236":"2746fda9","266":"a40c0623","323":"ccd10979","594":"8baa05af","618":"7fe87044","699":"ba0d989d","728":"fe0336d6","751":"2ec37d40","798":"17741041","847":"a64a878b","924":"9d2536cb"}[chunkId] + ".chunk.js";
};